import cosmeticData from "../data/cosmetics.json";

/**
 * Cosmetics catalog (ideas #10/#11, spec §15.3): tile skins are CSS filters
 * layered over the celestial art; board themes recolor the in-game board
 * panel. Bought once with stardust, owned forever (progress.ownedCosmetics).
 */
export interface CosmeticDef {
  id: string; // "skin:neon" | "theme:nebula" | ...
  type: "skin" | "theme";
  cost: number;
  icon: string;
}

export const COSMETICS: readonly CosmeticDef[] = cosmeticData as CosmeticDef[];

const BY_ID = new Map<string, CosmeticDef>(COSMETICS.map((c) => [c.id, c]));

export function getCosmetic(id: string): CosmeticDef | undefined {
  return BY_ID.get(id);
}

/** The equip value stored in settings ("neon" from "skin:neon"). */
export function equipValue(id: string): string {
  return id.split(":")[1] ?? id;
}

/** Free defaults that every player owns implicitly. */
export const DEFAULT_SKIN = "classic";
export const DEFAULT_THEME = "default";
